import React, { useEffect } from "react";
import styled from "styled-components";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import {
  clearSchedulePageAction,
  clearSelectedScheduleAction,
  scheduleState,
} from "../app/reducers/schedule-slice";
import { ScheduleLineDashboard } from "../components/board/ScheduleLineDashboard";

interface Props {
  asignmentStatus: string[];
}

export const ScheduleFormLineView: React.FC<Props> = ({ asignmentStatus }) => {
  const dispatch = useAppDispatch();
  const { dateToWork } = useAppSelector(scheduleState);

  useEffect(() => {
    return () => {
      dispatch(clearSchedulePageAction());
      dispatch(clearSelectedScheduleAction());
    };
  }, []);

  return (
    <ScheduleFormClassContainer>
      <ScheduleCreateMapContainer>
        <ScheduleLineContainer>
          <ScheduleLineDashboard
            selectLineMatchStatus={asignmentStatus}
            dateToWork={dateToWork}
          />
        </ScheduleLineContainer>
      </ScheduleCreateMapContainer>
    </ScheduleFormClassContainer>
  );
};

const ScheduleFormClassContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`;

const ScheduleCreateMapContainer = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
`;

const ScheduleLineContainer = styled.div`
  width: 100%;
  height: 100%;
  background-color: #000000;
`;
